import { createSlice } from '@reduxjs/toolkit';
import { Resource } from 'model/Resource';
import {
  fetchCompanyList,
  fetchCompanyProjectList,
  fetchMergeConnections,
} from 'reduxStore/company/asyncActions';
import { CompanyState, STORE_NAME } from 'reduxStore/company/initialState';
import { addAsyncCasesNew } from 'shared/utils/redux';

export const companySlice = createSlice({
  name: STORE_NAME,
  initialState: CompanyState.INITIAL_DOMAIN,
  reducers: {
    clearMergeConnections: (state) => {
      state.mergeConnectionsResource = Resource.createResolvedResource({ data: [] });
    },
  },
  extraReducers: (builder) => {
    addAsyncCasesNew(builder, fetchCompanyList, (state, action) => {
      state.listResource = action.payload;
    });
    addAsyncCasesNew(builder, fetchCompanyProjectList, (state, action) => {
      state.projectListResource = action.payload;
    });
    addAsyncCasesNew(builder, fetchMergeConnections, (state, action) => {
      state.mergeConnectionsResource = action.payload;
    });
  },
});

export const { clearMergeConnections } = companySlice.actions;
